import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=91e2c970&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"
import style0 from "./DataProtection.vue?vue&type=style&index=0&id=91e2c970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e2c970",
  null
  
)

export default component.exports